exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".alert-message{\n  height: 100% !important;\n  margin-bottom: 2rem !important;\n}\n.instructions {\n  padding-bottom: 0rem;\n}\n", ""]);

// exports
